import {
  ActionIcon,
  Button,
  Center,
  CopyButton,
  Divider,
  Group,
  Modal,
  NumberInput,
  Pagination,
  Paper,
  PasswordInput,
  SegmentedControl,
  Select,
  SelectProps,
  Table,
  Text,
  Textarea,
  TextInput,
  Tooltip,
} from "@mantine/core";
import {
  Container,
  Grid2 as Grid,
  Grid2Props as GridProps,
} from "@mui/material";

import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import {
  IconAt,
  IconColumns,
  IconEdit,
  IconEye,
  IconKey,
  IconLayoutGrid,
  IconPhoto,
  IconPlus,
  IconRefresh,
  IconReload,
  IconSearch,
  IconUpload,
  IconUser,
  IconX,
} from "@tabler/icons-react";
import {
  BrandImages,
  Colors,
  iCloudStorageList,
  ServiceList,
} from "../../Lib/Data";
import {
  PaginationProps,
  PlanProps,
  PossibleServices,
  UserProfileProps,
  ViewModesProps,
} from "../../Lib/Types";

import { DateInput } from "@mantine/dates";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import { GridRenderCellParams } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import DatagridDisplay from "../../Components/DatagridDisplay";
import DisplayAlert from "../../Components/DisplayAlert";
import MegaLoader from "../../Components/MegaLoader";
import { Endpoints } from "../../Lib/Endpoints";
import {
  DefaultErrorNotification,
  DefaultSuccessNotification,
  generateRandomString,
  generateSecurePassword,
  getEllipsisFromString,
  getPaginationTotal,
  parseString,
  showValidationErrors,
  validateEmail,
} from "../../Lib/Methods";
import { NonPaginatedResponse, PaginatedResponse } from "../../Lib/Responses";
import {
  PerformRequest,
  UploadFiles,
  usePerformRequest,
} from "../../Lib/usePerformRequest";
import "./styles.scss";
import { Link, useNavigate } from "react-router-dom";

const selectProps: SelectProps = {
  allowDeselect: false,
};
const gridItemProps: GridProps = {
  size: {
    xl: 3,
    lg: 4,
    md: 4,
    sm: 6,
    xs: 12,
  },
};
const Plans: React.FC = () => {
  type FilterFormProps = {
    service: PossibleServices | "";
    status: "active" | "expired";
    isFilledSlots: "open" | "closed";
  };
  const filterForm = useForm<FilterFormProps>({
    initialValues: {
      service: "",
      status: "active",
      isFilledSlots: "open",
    },
  });

  const [pagination, setPagination] = useState<PaginationProps>({
    page: 1,
    limit: 20,
  });
  const {
    data: plans,
    reloadData: reloadPlans,
    isLoading: isLoadingPlans,
  } = usePerformRequest<PaginatedResponse<PlanProps[]>>({
    route: `${Endpoints.GetPlans(pagination.page, pagination.limit)}`,
    method: "POST",
    body: {
      service: ServiceList.includes(filterForm.values.service as any)
        ? filterForm.values.service
        : undefined,
      status: filterForm.values.status,
      isFilledSlots: filterForm.values.isFilledSlots === "open" ? false : true,
    },
  });
  const [spotifyImageError, setSpotifyImageError] = useState<boolean>(false);

  useEffect(() => {
    reloadPlans();
  }, [pagination]);
  useEffect(() => {
    setPagination({ ...pagination, page: 1 });
  }, [filterForm.values]);

  const planForm = useForm<PlanProps>({
    initialValues: {
      id: "",
      subscriptionDate: dayjs().toString(),
      expirationDate: dayjs().add(30, "day").toString(),
      // @ts-ignore
      service: "Netflix",
      users: [],
      // @ts-ignore
      slots: 4,
      login: {
        email: "",
        password: "",
      },
      // @ts-ignore
      address: {
        image: "",
        value: "",
      },
      // @ts-ignore
      iCloudStorage: "10GB",
    },
    validate: {
      service: (value: PossibleServices) =>
        value && value.length > 0 ? null : "Please select a service",
      slots: (value: number) =>
        value && value > 0 ? null : "Enter number of available slots",
      login: {
        email: (value) =>
          validateEmail(value) ? null : "Enter a valid email address",
        password: (value) => (value.length >= 6 ? null : "Min: 6 Characters"),
      },
      // @ts-ignore
      iCloudStorage: (value, values) =>
        values.service !== "iCloud - Apple Music"
          ? null
          : !value || value.length === 0
          ? "Select iCloud storage!"
          : null,
      address: {
        image: (value, values) =>
          values.service !== "Spotify Premium"
            ? null
            : tempSpotifyImage === undefined
            ? planModalAction === "create"
              ? "Upload an image"
              : null
            : null,
        value: (value, values) =>
          values.service !== "Spotify Premium"
            ? null
            : value.length === 0
            ? "Enter address!"
            : null,
      },
    },
  });

  const [viewMode, setViewMode] = useState<ViewModesProps>("grid");

  const [viewingPlan, setViewingPlan] = useState<PlanProps>();

  const [planModalAction, setPlanModalAction] = useState<
    "create" | "update" | "view"
  >("create");

  const [isPlanModalOpened, { open: OpenPlanModal, close: ClosePlanModal }] =
    useDisclosure(false);

  const [tempSpotifyImage, setTempSpotifyImage] = useState<File>();

  const [isCreatingOrUpdatingPlan, setCreatingOrUpdatingPlan] =
    useState<boolean>(false);

  const navigate = useNavigate();

  const CreateNewPlan = async () => {
    const { hasErrors: formHasErrors } = planForm.validate();
    console.log(planForm.validate());
    // @ts-ignore
    const { expirationDate, subscriptionDate, service, slots, login, address } =
      planForm.values;
    if (service === "Spotify Premium") {
      setSpotifyImageError(tempSpotifyImage === undefined);
    }
    if (!formHasErrors) {
      let data = {
        service,
        isFilledSlots: false,
        subscriptionDate,
        expirationDate,
        slots,
        login: {
          email: parseString(login.email, true),
          password: parseString(login.password),
        },
      };

      const create = async (data: any) => {
        setCreatingOrUpdatingPlan(true);
        const r = await PerformRequest({
          method: "POST",
          route: Endpoints.GetCreateNewPlan(),
          data,
          callback: () => {
            setCreatingOrUpdatingPlan(false);
          },
        });
        setCreatingOrUpdatingPlan(false);
        if (r) {
          if (r.status === 403) {
            showValidationErrors(r);
          }
          if (r.status === 201) {
            CancelCreatePlan();
            reloadPlans();
            DefaultSuccessNotification("Plan created successfully!");
          }
        }
      };
      if (service === "Spotify Premium" && tempSpotifyImage) {
        // UPLOAD ADDRESS IMAGE
        setCreatingOrUpdatingPlan(true);
        UploadFiles([tempSpotifyImage])
          .catch(() => {
            setCreatingOrUpdatingPlan(false);
            DefaultErrorNotification("Could not upload image!");
          })
          .then((uploaded) => {
            if (uploaded) {
              if (uploaded.status === 201) {
                // FILE WAS UPLOADED SUCCESSFULLY!
                create({
                  ...data,
                  address: {
                    image: uploaded?.data[0]?.path,
                    value: address.value,
                  },
                });
              }
            }
          });
      } else {
        if (service === "iCloud - Apple Music") {
          data = {
            ...data,
            // @ts-ignore
            iCloudStorage: planForm.values.iCloudStorage,
          };
          create(data);
        } else {
          create(data);
        }
      }
    }
  };

  const [isSpotifyImageUpdated, setSpotifyImageUpdated] =
    useState<boolean>(false);
  const UpdatePlanDetails = async () => {
    const { hasErrors: formHasErrors } = planForm.validate();
    const {
      id,
      expirationDate,
      subscriptionDate,
      service,
      slots,
      login,
      // @ts-ignore
      address,
    } = planForm.values;

    if (!formHasErrors) {
      let data = {
        id,
        service,
        isFilledSlots: false,
        subscriptionDate: dayjs(subscriptionDate).toString(),
        expirationDate: dayjs(expirationDate).toString(),
        slots,
        login: {
          email: parseString(login.email, true),
          password: parseString(login.password),
        },
      };
      const update = async (data: any) => {
        setCreatingOrUpdatingPlan(true);
        const r = await PerformRequest({
          method: "POST",
          route: Endpoints.GetUpdateExistingPlan(),
          data,
          callback: () => {
            setCreatingOrUpdatingPlan(false);
          },
        });
        setCreatingOrUpdatingPlan(false);
        if (r) {
          if (r.status === 403) {
            showValidationErrors(r);
          }
          if (r.status === 200) {
            CancelCreatePlan();
            reloadPlans();
            DefaultSuccessNotification("Plan updated successfully!");
          }
        }
      };
      if (service === "Spotify Premium") {
        // HAS ADDRESS IMAGE BEEN UPDATED
        if (isSpotifyImageUpdated) {
          // UPLOAD ADDRESS IMAGE
          setCreatingOrUpdatingPlan(true);
          UploadFiles([tempSpotifyImage as File])
            .catch(() => {
              setCreatingOrUpdatingPlan(false);
              DefaultErrorNotification("Could not upload image!");
            })
            .then((uploaded) => {
              if (uploaded) {
                if (uploaded.status === 201) {
                  // FILE WAS UPLOADED SUCCESSFULLY!
                  update({
                    ...data,
                    address: {
                      image: uploaded?.data[0]?.path,
                      value: address.value,
                    },
                  });
                }
              }
            });
        } else {
          update({
            ...data,
            address: {
              image: address.image,
              value: address.value,
            },
          });
        }
      } else {
        if (service === "iCloud - Apple Music") {
          data = {
            ...data,
            // @ts-ignore
            iCloudStorage: planForm.values.iCloudStorage,
          };
          update(data);
        } else {
          update(data);
        }
      }
    } else {
    }
  };
  const CancelCreatePlan = () => {
    planForm.reset();
    ClosePlanModal();
    setTempSpotifyImage(undefined);
    setCurrentPlanUsers([]);
  };
  const planFormInputProps = {
    my: 5,
  };

  const [currentPlanUsers, setCurrentPlanUsers] = useState<UserProfileProps[]>(
    []
  );
  const [isLoadingUsers, setLoadingUsers] = useState<boolean>(false);

  const GetUsersInCurrentPlan = async () => {
    setCurrentPlanUsers([]);
    if (viewingPlan && viewingPlan.id && viewingPlan.users.length > 0) {
      setLoadingUsers(true);
      const r = await PerformRequest<NonPaginatedResponse<UserProfileProps[]>>({
        method: "POST",
        route: Endpoints.GetUsersByArray(),
        data: {
          ids: viewingPlan.users,
        },
        callback: () => {
          setLoadingUsers(false);
        },
      });
      setLoadingUsers(false);
      if (r) {
        if (r.status === 200 && r?.data?.data) {
          setCurrentPlanUsers(r.data.data);
        } else {
          DefaultErrorNotification("Could not get users!");
        }
      } else {
        DefaultErrorNotification("Could not get users!");
      }
    }
  };
  const searchForm = useForm({
    initialValues: {
      id: "",
    },
    validate: {
      id: (value) => (value.length > 0 ? null : "Enter a valid plan ID"),
    },
  });
  const SearchByID = async () => {
    const { hasErrors: formHasErrors } = searchForm.validate();
    if (!formHasErrors) {
      const r = await PerformRequest<NonPaginatedResponse<PlanProps>>({
        method: "GET",
        route: Endpoints.GetSinglePlan(searchForm.values.id),
      });
      if (r) {
        if (r.status === 200) {
          setViewingPlan(r.data.data);
          setPlanModalAction("view");
          OpenPlanModal();
        } else {
          DefaultErrorNotification("Could not find plan!");
        }
      }
    }
  };
  return (
    <Container maxWidth="lg">
      <div className="plans-container">
        <div className="component-header flex-row align-end justify-between">
          <Text className="label">Plans</Text>
          <div className="flex-row align-center">
            <Button
              color={Colors.GreenPrimary}
              rightSection={<IconPlus size={16} />}
              mr={10}
              onClick={() => {
                setPlanModalAction("create");
                setViewingPlan(undefined);
                OpenPlanModal();
                planForm.reset();
                planForm.setFieldValue(
                  "service",
                  filterForm.values.service as typeof planForm.values.service
                );
              }}
              disabled={isCreatingOrUpdatingPlan || isLoadingPlans}
            >
              Add Plan
            </Button>
            <Button
              color={Colors.GreenPrimary}
              variant="outline"
              onClick={reloadPlans}
              loading={isLoadingPlans}
              rightSection={<IconReload size={16} />}
            >
              Reload
            </Button>
          </div>
        </div>
        <br />
        <div className="flex-row align-center justify-between width-100">
          <div className="filters flex-row align-end">
            <Select
              w={190}
              {...selectProps}
              {...filterForm.getInputProps("service")}
              label="Service"
              mr={10}
              data={[
                { value: "", label: "All" },
                ...ServiceList.map((service) => {
                  return {
                    value: service,
                    label: service,
                  };
                }),
              ]}
            />
            <Select
              w={100}
              {...selectProps}
              {...filterForm.getInputProps("isFilledSlots")}
              label="Vacancy"
              mr={10}
              data={[
                { label: "Open", value: "open" },
                { label: "Closed", value: "closed" },
              ]}
            />
            <Select
              w={140}
              {...selectProps}
              {...filterForm.getInputProps("status")}
              label="Status"
              data={[
                { label: "Active", value: "active" },
                { label: "Expired", value: "expired" },
              ]}
            />
          </div>
          <SegmentedControl
            mt={10}
            withItemsBorders={false}
            size="md"
            value={viewMode}
            onChange={(value) => {
              setViewMode(value as ViewModesProps);
            }}
            data={[
              {
                label: (
                  <Center style={{ gap: 10 }}>
                    <IconColumns size={20} />
                  </Center>
                ),
                value: "table",
              },
              {
                label: (
                  <Center style={{ gap: 10 }}>
                    <IconLayoutGrid size={20} />
                  </Center>
                ),
                value: "grid",
              },
            ]}
          />
        </div>
        <br />
        <div className="flex-row align-center">
          <TextInput
            w={280}
            {...searchForm.getInputProps("id")}
            placeholder="Search by plan ID"
          />
          <ActionIcon ml={20} onClick={SearchByID} size="lg">
            <IconSearch />
          </ActionIcon>
        </div>
        <div className="plans">
          {isLoadingPlans ? (
            <MegaLoader
              size={50}
              containerStyle={{
                marginTop: 45,
                marginBottom: 45,
              }}
            />
          ) : (
            <>
              {!plans?.data || plans?.data.length === 0 ? (
                <DisplayAlert
                  title="No Plans Found"
                  children={<Text>No plans matching this criteria!</Text>}
                />
              ) : (
                <>
                  {viewMode === "grid" ? (
                    <Grid spacing={2} container>
                      {plans?.data?.map((plan) => {
                        return (
                          <Grid {...gridItemProps} key={plan.id}>
                            <Paper
                              withBorder
                              className="plan flex-col justify-between"
                            >
                              <div className="flex-row align-center justify-between">
                                <Text c={Colors.BlackPrimary} fz={15}>
                                  {plan.service}
                                </Text>
                                <img
                                  src={BrandImages.retrieveImage(plan.service)}
                                  alt=""
                                  className="plan-image-thumbnail"
                                />
                              </div>
                              <div className="flex0-col">
                                <Text c="dimmed" fw={600} fz={13}>
                                  Expiration Date
                                </Text>
                                <Text
                                  c={
                                    dayjs(plan.expirationDate).isBefore(dayjs())
                                      ? Colors.RedPrimary
                                      : Colors.GreenSecondary
                                  }
                                  fz={13}
                                >
                                  {dayjs(plan.expirationDate).format(
                                    "ddd, MMMM DD YYYY"
                                  )}
                                </Text>
                              </div>
                              <div className="flex-row align-center justify-between width-100">
                                <Button
                                  variant="outline"
                                  w={100}
                                  onClick={() => {
                                    OpenPlanModal();
                                    setPlanModalAction("update");
                                    // @ts-ignore
                                    planForm.setValues({
                                      id: plan.id,
                                      subscriptionDate: plan.subscriptionDate,
                                      expirationDate: plan.expirationDate,
                                      // @ts-ignore
                                      service: plan.service,
                                      // @ts-ignore
                                      slots: plan.slots,
                                      // @ts-ignore
                                      login: plan.login,
                                      // @ts-ignore
                                      iCloudStorage: plan.iCloudStorage,
                                    });
                                    if (plan.service === "Spotify Premium") {
                                      planForm.setFieldValue(
                                        "address",
                                        plan.address
                                      );
                                    }
                                  }}
                                >
                                  Edit
                                </Button>
                                <Button
                                  w={100}
                                  onClick={() => {
                                    navigate(`/dashboard/plan/${plan.id}`);
                                  }}
                                >
                                  View
                                </Button>
                              </div>
                            </Paper>
                          </Grid>
                        );
                      })}
                    </Grid>
                  ) : (
                    <DatagridDisplay
                      rows={plans?.data}
                      isLoading={isLoadingPlans}
                      columns={[
                        {
                          field: "service",
                          headerName: "Service",
                          renderCell: (
                            params: GridRenderCellParams<PlanProps>
                          ) => {
                            return (
                              <div className="flex-row flex-1 align-center">
                                <img
                                  className="plan-image-thumbnail"
                                  src={BrandImages.retrieveImage(
                                    params.row.service
                                  )}
                                />
                              </div>
                            );
                          },
                        },
                        {
                          field: "subscriptionDate",
                          flex: 1,
                          headerName: "Subscription Date",
                          renderCell: (
                            params: GridRenderCellParams<PlanProps>
                          ) => (
                            <div className="flex-row flex-1 align-center">
                              <Text c={Colors.BlackPrimary} fz={13}>
                                {dayjs(params.row.subscriptionDate).format(
                                  "ddd, MMMM DD YYYY"
                                )}
                              </Text>
                            </div>
                          ),
                        },
                        {
                          field: "expirationDate",
                          flex: 1,
                          headerName: "Expiration Date",
                          renderCell: (
                            params: GridRenderCellParams<PlanProps>
                          ) => (
                            <div className="flex-row flex-1 align-center">
                              <Text c={Colors.BlackPrimary} fz={13}>
                                {dayjs(params.row.expirationDate).format(
                                  "ddd, MMMM DD YYYY"
                                )}
                              </Text>
                            </div>
                          ),
                        },
                        {
                          headerName: "Total/Free (Slots)",
                          field: "slots",
                          width: 160,
                          renderCell: (
                            params: GridRenderCellParams<PlanProps>
                          ) => (
                            <div className="flex-row flex-1 align-center">
                              <Text c={Colors.BlackPrimary} fz={13}>
                                {params.row.slots} /{" "}
                                {params.row.slots - params.row.users.length}
                              </Text>
                            </div>
                          ),
                        },
                        {
                          headerName: "Actions",
                          field: "id",
                          flex: 1,
                          renderCell: (
                            params: GridRenderCellParams<PlanProps>
                          ) => (
                            <div className="flex-row flex-1 align-center">
                              <div className="flex-row align-center">
                                <ActionIcon
                                  variant="subtle"
                                  onClick={() => {
                                    OpenPlanModal();
                                    setPlanModalAction("update");
                                    // @ts-ignore
                                    planForm.setValues({
                                      id: params.row.id,
                                      subscriptionDate:
                                        params.row.subscriptionDate,
                                      expirationDate: params.row.expirationDate,
                                      // @ts-ignore
                                      service: params.row.service,
                                      // @ts-ignore
                                      slots: params.row.slots,
                                      // @ts-ignore
                                      login: params.row.login,
                                    });
                                    if (
                                      params.row.service === "Spotify Premium"
                                    ) {
                                      planForm.setFieldValue(
                                        "address",
                                        params.row.address
                                      );
                                    }
                                  }}
                                >
                                  <IconEdit size={18} />
                                </ActionIcon>
                                &nbsp; &nbsp;
                                <ActionIcon
                                  variant="subtle"
                                  onClick={() => {
                                    navigate(
                                      `/dashboard/plan/${params.row.id}`
                                    );
                                  }}
                                >
                                  <IconEye size={18} />
                                </ActionIcon>
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                  )}
                </>
              )}
            </>
          )}
          <div className="flex-row align-center justify-center width-100">
            <Pagination
              value={pagination.page}
              onChange={(value) => {
                setPagination({ ...pagination, page: value });
              }}
              my={40}
              disabled={plans?.data.length === 0 || isLoadingPlans}
              total={getPaginationTotal(plans?.totalRecords, pagination.limit)}
            />
          </div>
        </div>
      </div>
      <Modal
        opened={isPlanModalOpened}
        onClose={CancelCreatePlan}
        centered
        size="lg"
        withCloseButton={false}
      >
        <div className="plan-modal flex-col">
          <div className="flex-row align-center width-100 justify-between">
            <div className="flex-row align-center">
              <Text tt="capitalize" c={Colors.BluePrimary} fw={500} fz={17}>
                {planModalAction} Plan
              </Text>
              <img
                src={BrandImages.retrieveImage(planForm.values.service)}
                alt=""
                className="logo"
              />
            </div>
            <ActionIcon
              variant="outline"
              color={Colors.BluePrimary}
              onClick={CancelCreatePlan}
            >
              <IconX color={Colors.BluePrimary} size={18} />
            </ActionIcon>
          </div>
          {planModalAction === "view" ? (
            <>
              {viewingPlan && (
                <>
                  <Table
                    mt={20}
                    variant="vertical"
                    layout="fixed"
                    withTableBorder
                  >
                    <Table.Thead>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th w={200}>Plan ID</Table.Th>
                        <Table.Td>
                          <CopyButton value={viewingPlan.id}>
                            {({ copied, copy }) => (
                              <Tooltip
                                label={copied ? "Copied!" : "Copy to clipboard"}
                              >
                                <div
                                  className="pointer flex-row align-center"
                                  onClick={copy}
                                  style={{
                                    color: copied
                                      ? Colors.GreenPrimary
                                      : Colors.BluePrimary,
                                    height: "100%",
                                  }}
                                >
                                  {viewingPlan.id}
                                </div>
                              </Tooltip>
                            )}
                          </CopyButton>
                        </Table.Td>
                      </Table.Tr>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th>Service</Table.Th>
                        <Table.Td>
                          <div className="flex-row align-center temp-service-images">
                            <img
                              src={BrandImages.retrieveImage(
                                viewingPlan.service
                              )}
                              alt=""
                              className="image"
                            />
                          </div>
                        </Table.Td>
                      </Table.Tr>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th>Available Slots</Table.Th>
                        <Table.Td>
                          {viewingPlan.slots - viewingPlan.users.length}
                        </Table.Td>
                      </Table.Tr>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th>Total Slots</Table.Th>
                        <Table.Td>{viewingPlan.slots}</Table.Td>
                      </Table.Tr>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th>Last Subscription Date</Table.Th>
                        <Table.Td>
                          {dayjs(viewingPlan.subscriptionDate).format(
                            "ddd, MMMM DD YYYY"
                          )}
                        </Table.Td>
                      </Table.Tr>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th>Expiration Date</Table.Th>
                        <Table.Td>
                          {dayjs(viewingPlan.expirationDate).format(
                            "ddd, MMMM DD YYYY"
                          )}
                        </Table.Td>
                      </Table.Tr>
                    </Table.Thead>
                  </Table>
                  {viewingPlan?.users?.length > 0 && (
                    <>
                      {currentPlanUsers.length > 0 ? (
                        <>
                          <Divider w="100%" mt={20} mb={15} />
                          <Text
                            mb={10}
                            ml={20}
                            fz="sm"
                            fw={600}
                            c={Colors.BluePrimary}
                          >
                            Users
                          </Text>
                          {currentPlanUsers.map((user) => {
                            return (
                              <Link to={`/dashboard/user/${user.id}`}>
                                <Button
                                  leftSection={<IconUser size={17} />}
                                  variant="subtle"
                                  ta="left"
                                  className="flex-row align-start justify-start"
                                  color={Colors.GreenPrimary}
                                  w={"100%"}
                                >
                                  {user.name}
                                </Button>
                              </Link>
                            );
                          })}
                        </>
                      ) : (
                        <div className="flex-row align-center">
                          <Button
                            color={Colors.GreenPrimary}
                            loading={isLoadingUsers}
                            w={120}
                            mt={20}
                            mr={20}
                            onClickCapture={GetUsersInCurrentPlan}
                          >
                            Get Users
                          </Button>
                          <Link to={`/dashboard/plan/${viewingPlan.id}`}>
                            <Button mt={20}>View Plan</Button>
                          </Link>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <div className="flex-row align-center justify-between width-100">
                <Select
                  disabled={planModalAction === "update"}
                  label="Service"
                  {...selectProps}
                  {...planForm.getInputProps("service")}
                  {...planFormInputProps}
                  w="48%"
                  data={ServiceList.map((service) => {
                    return {
                      value: service,
                      label: service,
                    };
                  })}
                />
                <NumberInput
                  {...planForm.getInputProps("slots")}
                  label="Slots"
                  min={1}
                  spellCheck={false}
                  placeholder="Number of slots"
                  w="48%"
                />
              </div>
              <div className="flex-row align-center justify-between width-100">
                <DateInput
                  value={dayjs(planForm.values.subscriptionDate).toDate()}
                  onChange={(e) => {
                    if (e && e.toString) {
                      planForm.setFieldValue("subscriptionDate", e?.toString());
                    }
                  }}
                  label="Subscription Date"
                  placeholder="Date"
                  w="48%"
                  spellCheck={false}
                />
                <DateInput
                  value={dayjs(planForm.values.expirationDate).toDate()}
                  onChange={(e) => {
                    if (e && e.toString) {
                      planForm.setFieldValue("expirationDate", e?.toString());
                    }
                  }}
                  label="Expiration Date"
                  placeholder="Expiration Date"
                  w="48%"
                  spellCheck={false}
                />
              </div>
              <Divider w="100%" my={20} />
              {/* @ts-ignore */}
              {planForm.values.service === "iCloud - Apple Music" && (
                <>
                  <Select
                    label="iCloud Storage"
                    {...selectProps}
                    data={iCloudStorageList.map((storage) => {
                      return {
                        value: storage,
                        label: storage,
                      };
                    })}
                    {...planForm.getInputProps("iCloudStorage")}
                    w="100%"
                  />
                  <Divider w="100%" my={20} />
                </>
              )}
              <TextInput
                {...planForm.getInputProps("login.email")}
                {...planFormInputProps}
                label="Email"
                placeholder="Enter login email"
                spellCheck={false}
                leftSection={<IconAt size={16} />}
              />
              <div className="flex-row align-end width-100 justify-between">
                <PasswordInput
                  {...planForm.getInputProps("login.password")}
                  {...planFormInputProps}
                  label="Password"
                  w="-webkit-fill-available"
                  placeholder="Enter login password"
                  spellCheck={false}
                  mr={10}
                  leftSection={<IconKey size={16} />}
                />
                <Button
                  w={180}
                  mb={5}
                  leftSection={<IconRefresh size={18} />}
                  color={Colors.BluePrimary}
                  onClick={() => {
                    planForm.setFieldValue(
                      "login.password",
                      generateSecurePassword()
                    );
                  }}
                >
                  Generate
                </Button>
              </div>
              {planForm.values.service === "Spotify Premium" && (
                <>
                  <Textarea
                    rows={4}
                    label="Address"
                    spellCheck={false}
                    placeholder="Enter house address"
                    {...planForm.getInputProps("address.value")}
                    mb={10}
                  />
                  <Dropzone
                    onDrop={(files) => {
                      if (planModalAction === "update") {
                        // SPOTIFY ADDRESS HAS CHANGED AND MUST BE RE-UPLOADED
                        setSpotifyImageUpdated(true);
                      }
                      setTempSpotifyImage(files[0]);
                      setSpotifyImageError(false);
                    }}
                    disabled={isCreatingOrUpdatingPlan}
                    maxFiles={1}
                    onReject={(files) => {
                      DefaultErrorNotification("Invalid file or too large!");
                    }}
                    maxSize={5 * 1024 ** 2}
                    accept={IMAGE_MIME_TYPE}
                    style={{
                      borderColor: spotifyImageError
                        ? Colors.RedPrimary
                        : Colors.GrayPrimary,
                    }}
                  >
                    {tempSpotifyImage || planModalAction === "update" ? (
                      <div className="temp-image-container flex-row align-center justify-center">
                        <img
                          src={
                            tempSpotifyImage
                              ? URL.createObjectURL(tempSpotifyImage)
                              : planForm.values.address.image
                          }
                          alt=""
                          className="temp-image"
                        />
                      </div>
                    ) : (
                      <Group
                        justify="center"
                        gap="xl"
                        h={180}
                        style={{ pointerEvents: "none" }}
                      >
                        <Dropzone.Accept>
                          <IconUpload
                            size={52}
                            color="var(--mantine-color-blue-6)"
                            stroke={1.5}
                          />
                        </Dropzone.Accept>
                        <Dropzone.Reject>
                          <IconX
                            size={52}
                            color="var(--mantine-color-red-6)"
                            stroke={1.5}
                          />
                        </Dropzone.Reject>
                        <Dropzone.Idle>
                          <IconPhoto
                            size={52}
                            color="var(--mantine-color-dimmed)"
                            stroke={1.5}
                          />
                        </Dropzone.Idle>

                        <div className="flex-col align-center">
                          <Text ta="center" size="lg" inline>
                            Drop Address Image or Click to Upload
                          </Text>
                          <Text ta="center" size="sm" c="dimmed" inline mt={7}>
                            Max file size: 5mb
                          </Text>
                        </div>
                      </Group>
                    )}
                  </Dropzone>
                </>
              )}
              <div className="flex-row width-100 justify-between align-center">
                <Button
                  mt={10}
                  w="48%"
                  tt="capitalize"
                  color={Colors.GreenPrimary}
                  onClick={
                    planModalAction === "create"
                      ? CreateNewPlan
                      : UpdatePlanDetails
                  }
                  loading={isCreatingOrUpdatingPlan}
                >
                  {planModalAction}
                </Button>
                <Button
                  mt={10}
                  w="48%"
                  variant="outline"
                  onClick={CancelCreatePlan}
                  disabled={isCreatingOrUpdatingPlan}
                  color={Colors.RedPrimary}
                >
                  Cancel
                </Button>
              </div>
            </>
          )}
        </div>
      </Modal>
    </Container>
  );
};

export default Plans;
